import { Callout, COLOR, font, Icon, mixins, SearchInput } from '@cosuno/cosuno-ui';
import styled, { css } from 'styled-components';

export const HeadingMedium = styled.h3`
  padding-bottom: 5px;
  ${font.bold}
  ${font.size(32)}
`;

export const HeadingSmall = styled.h5`
  padding-bottom: 40px;
  ${font.bold}
  ${font.size(24)}
  line-height: 1.5;
`;

export const HeadingSmallest = styled.h6`
  ${font.bold}
  ${font.size(14)}
`;

export const SubcontractorStatsDetail = styled.div`
  margin-right: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  ${font.size(14)}
`;

export const SubcontractorStatsIcon = styled(Icon)`
  margin-right: 5px;
  color: ${COLOR.textTertiary};
`;

export const StatsRow = styled.div`
  display: flex;
  flex-direction: row;
  color: ${COLOR.textTertiary};
`;

export const SectionHint = styled(Callout).attrs({ size: 'compact' })`
  margin-bottom: 20px;
`;

interface SpaceBetweenProps {
  $centerVertically?: boolean;
}

export const SpaceBetween = styled.div<SpaceBetweenProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${(props) =>
    props.$centerVertically &&
    css`
      align-items: center;
    `}
`;

export const TableSearch = styled(SearchInput)`
  width: 200px;
`;

export const PermissionsTip = styled(Callout).attrs({ size: 'compact' })`
  margin-bottom: 30px;
`;

export const PermissionsTipLink = styled.a`
  ${mixins.link()};
`;

export const stickyHeaderStyles = css`
  left: 0;
  position: sticky;
`;

export const FullWidthWrapper = styled.div`
  width: 100%;
`;
